/**
 * AccountType
 * Enum representing user account types.
 *
 * @property User - Standard student/teacher/admin account.
 * @property Parent - Parent account linked to one or more students.
 */
export enum AccountType {
  User = 'user',
  Parent = 'parent',
}
